<template>
  <li class="nav-item" :class="'layer' + layer" @click.stop="navClick(data)">
    <div class="nav-item-text" v-if="layer === 1">
      <i
        :class="[
          'gw-icon',
          iconUnicodeList[index % iconUnicodeList.length].ico,
        ]"
      ></i>
      {{ data.name }}
    </div>
    <div class="nav-item-text" v-else>{{ data.name }}</div>
    <ul v-if="data.children" class="nav-item-ul">
      <nav-item
        v-for="(item, childIndex) in data.children"
        :key="childIndex"
        :data="item"
        :layer="layer + 1"
        :index="childIndex"
        :coreProductTypeName="coreProductTypeName"
        :parentData="data"
        @pageSkip="pageSkip"
        :TypeLists="TypeLists"
      ></nav-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: "NavItem",
  props: {
    data: Object,
    layer: Number,
    index: {
      type: Number,
      default: 0,
    },
    coreProductTypeName: {
      type: String,
      default: '',
    },
    parentData: {
      type: Object,
      default: null,
    },
    TypeLists: {
      type: Array,
      default: null,
    },
    CaseLists: {
      type: Array,
      default: null,
    },
  },
  created() {
    // console.log("this.TypeLists",this.TypeLists);
  },
  data() {
    return {
  
      iconUnicodeList: [
        // 关于星科
        { ico: "icon-gongsijianjie" }, //公司简介
        { ico: "icon-fazhanlicheng1" }, //发展历程
        { ico: "icon-zhuanyezhuanyeke" }, //核心竞争力
        { ico: "icon-xinwenzhongxin1" }, //新闻中心
        { ico: "icon-touzizheguanxi" }, //投资者关系

        // AI+教育解决方案
        { ico: "icon-icon_onfindcar_36" }, //汽车技术
        { ico: "icon-zhinengzhizao" }, //智能制造
        { ico: "icon-jidian1" }, //智慧机电
        { ico: "icon-yejin" }, //黑色冶金
        { ico: "icon-yejinhangye" }, //有色冶金
        { ico: "icon-xiaofang" }, //智慧消防
        { ico: "icon-nuantongkongtiao" }, //暖通空调
        { ico: "icon-tubiaoshangchuanmoban" }, //能源储能
        { ico: "icon-gangkouyewu-gangkou" }, //港口机械
        { ico: "icon-zhihuinongye" }, //智慧农业
        { ico: "icon-jiaoyu" }, //思政教育
        { ico: "icon-zhiyesuyang" }, //职业素养
        { ico: "icon-kuangshanjixie" }, //矿物加工


        // AI+工业
        { ico: "icon-shuzihuazhuanxing" }, // 工业数字化转型
        { ico: "icon-a-miaoshuliangangshengchanzhuangtaishixiao" }, // 智能可视化模型炼钢

        // 培训业务 
        { ico: "icon-xuexiwangke" }, //行知学徒网
        { ico: "icon-cooperativeedu" }, //校企合作办学
        { ico: "icon-xianxiapeixun" }, //线下培训
        { ico: "icon-xianxiapeixun1" } //教师培训
       
      ],
    };
  },
  methods: {
    // navClick(route) {
    //   console.log("route对象",route);

    //   console.log("route.path",route.path);

      
    //   // 原有逻辑
    //   if (route.path) {
    //     if (this.$router.currentRoute.path !== route.path) {
    //       if (route.path.indexOf("http") != -1) {
    //         window.open(route.path, "_blank");
    //       } else {
    //         this.$router.push({
    //           path: route.path,
    //         });
    //       }
    //     }
    //     this.$emit("pageSkip");
    //   }
    // },
     navClick(route) {
    console.log("route对象", route);
    console.log("route.path", route.path);
    if (route.path) {
      if (route.path.indexOf("http") !== -1) {
        // 外部链接，新窗口打开
        window.open(route.path, "_blank");
        this.$emit("pageSkip");
        return;
      }

      // 处理内部路由
      try {
        const urlParts = route.path.split('?');
        const path = urlParts[0];
        const query = {};
        
        // 解析查询参数
        if (urlParts.length > 1) {
          const queryString = urlParts[1];
          const params = new URLSearchParams(queryString);
          
          for (const [key, value] of params) {
            query[key] = value;
          }
        }

        console.log("跳转到:", { path, query });

        // 检查是否是当前路由（包括参数对比）
        const currentRoute = this.$router.currentRoute;
        const isSameRoute = currentRoute.path === path && 
          JSON.stringify(currentRoute.query) === JSON.stringify(query);

        if (!isSameRoute) {
          this.$router.push({
            path: path,
            query: query
          });
        }

        this.$emit("pageSkip");
      } catch (error) {
        console.error("路由跳转错误:", error);
        // 如果解析失败，尝试直接跳转
        this.$router.push(route.path);
      }
    }
  },
    pageSkip() {
      this.$emit("pageSkip");
    },
  },
};
</script>

<style scoped>
.pc-box .nav-item-container .layer1 {
  font-size: 15px;
  margin: 20px 1%;
  width: 23%;
  box-sizing: border-box;
  text-align: left;
  box-sizing: border-box;
}
.pc-box .nav-item-container .layer1 .nav-item-text {
  border-bottom: 1px solid #e4e6eb;
  padding-bottom: 15px;
  color: #333333;
  font-size: 15px;
  font-weight: 600;
}
.pc-box .nav-item-container .layer1 .nav-item-text i{
  font-weight: normal;
  font-size: 16px;
}
.pc-box .nav-item-container .layer1:hover > .nav-item-text {
  color: #333;
}
.pc-box .nav-item-container .layer2 .nav-item-text {
  border-bottom: none;
  font-weight: normal;
  font-size: 14px;
  float: left;
  
}
.pc-box .nav-item-container .layer2:hover .nav-item-text {
  color: #eb580e;
  font-weight: normal;
}
.nav-item {
  width: 100%;
  height: auto;
}
.nav-item ul {
  display: none; /* 默认隐藏子菜单 */
  text-indent: 1.58em;
  margin-top: 10px;
  height: 40px;
}

/* 当鼠标悬停在nav-item-text上时显示子菜单 */
.nav-item:hover .nav-item-ul,
.nav-item .nav-item-text:hover + .nav-item-ul {
  display: block;
}
.nav-item ul li {
  transition: max-height 0.3s ease;
  width: auto;
  line-height: 40px;
  /* padding: 0 0 10px; */
}
.nav-item:hover ul li {
  transition: all 0.3s ease;
  opacity: 1;
}
</style>











// WEBPACK FOOTER //
// src/components/NavMenu/NavItem.vue